export const SERVER_VALIDATION_ERROR_MESSAGE_ID =
	'field-flags-service.server-validation-error-message';
